import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel } from '../../uicomponent';
import * as React from 'react';
import { SearchBoxComponentProps, SearchBoxComponentHandler, SearchBoxComponentState } from './searchboxcomponent';
import { SearchBoxCSSStyle } from './searchboxcss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import "./search-style.css";


export class SearchBoxViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private searchInput: HTMLInputElement | null;

    bindHandlers()
    {
        this.onSearchBoxClick = this.onSearchBoxClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.clearData = this.clearData.bind(this);
    }

    draw(props: SearchBoxComponentProps, state: SearchBoxComponentState, cssStyle: SearchBoxCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

       return (
            <>
                {
                    this.getWebView(props, state, cssStyle)
                }
           
            </>
       );
    }

    getWebView(props: SearchBoxComponentProps, state: SearchBoxComponentState, cssStyle: SearchBoxCSSStyle):JSX.Element
    {
        return(
                <>
                 <div id="search-box-main" style={props.cssStyle.getMainDivCSSStyle()}>
                <input id="search-box-input" placeholder={props.context.getResources().getString(Strings.find_your_name)} onChange={this.onChange} value={state.searchKey} ref={(item: any) => {this.searchInput = item;}} type="search"  style={cssStyle.getSearchBoxInputDivCSSStyle()}/>
                 <div onClick={this.onSearchBoxClick} style={props.cssStyle.getSearchBoxImageDivCSSStyle()}>
                        <label id="search-box-label" style={cssStyle.getSearchLabelCSSStyle()}>
                            {this.getContext().getResources().getString(Strings.search)}
                        </label>
                        {/* <img src={props.context.getResources().getImage('search.svg')} height="15.59px" width="15.59px" /> */}
                 </div>

             </div>
                </>
        );
    }

    getMobileView(props: SearchBoxComponentProps, state: SearchBoxComponentState, cssStyle: SearchBoxCSSStyle):JSX.Element
    {
        return(
            <>
                 <div style={props.cssStyle.getMobileMainDivCSSStyle()}>
                <input placeholder={props.context.getResources().getString(Strings.find_your_name)} onChange={this.onChange} value={state.searchKey} ref={(item: any) => {this.searchInput = item;}} type="search" id='search' style={cssStyle.getMobileSearchBoxInputDivCSSStyle()}/>
                 <div onClick={this.onSearchBoxClick} style={props.cssStyle.getMobileSearchBoxImageDivCSSStyle()}>
                        <label style={cssStyle.getMobileSearchLabelCSSStyle()}>
                            {this.getContext().getResources().getString(Strings.search)}
                        </label>
                        {/* <img src={props.context.getResources().getImage('search.svg')} height="15.59px" width="15.59px" /> */}
                 </div>

             </div>
            </>
        );
    }

    onChange(e: any):void
    {
        if(this.searchInput !== null)
        {
            console.log("onChange() : " + e.target.value);
            (this.getUIComponentHandler() as SearchBoxComponentHandler).onChange(this.searchInput.value);
        }
    }

    onSearchBoxClick(e:any):void
    {
        e.preventDefault(); 
        if(this.searchInput !== null)
        {
            console.log("onSearchBoxClick() : " + this.searchInput.value);

            (this.getUIComponentHandler() as SearchBoxComponentHandler).onSearchBoxButtonClicked(this.searchInput.value);
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/searchbox/searchboxview.tsx